import React from "react";
import styles from './workOrderMobile.module.css';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select, Tab, Tabs, TextField } from "@mui/material";
import { ArrowLeft, Camera, Edit, File, FileText, MoreVertical, Plus, Trash2, X } from "react-feather";
import PropTypes from 'prop-types';
import { Dropdown } from "react-bootstrap";
import { LocalizationProvider, MobileDatePicker, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import { makeStyles } from "@material-ui/core/styles";
import VehicleAdd from "../Tabs/WorkOrderTab/Vehicle/VehicleAdd";
import { useState } from "react";
import MaterialAdd from "../Tabs/WorkOrderTab/Material/MaterialAdd";
import LaborAdd from "../Tabs/WorkOrderTab/Labor/LaborAdd";
import ContractorAdd from "../Tabs/WorkOrderTab/Contractor/ContractorAdd";
import AppointmentAdd from "../Tabs/WorkOrderTab/Appointment/AppointmentAdd";
import axios from "axios";
import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { AddLogCallAPI } from "../../../../components/AddLogs";
import { toast } from "react-smart-toaster";
import { Link } from "react-router-dom";

const Initials = ({ fullName }) => {
  const parts = fullName.trim().split(" ");
  if (parts.length >= 2) {
    return (
      parts[0].charAt(0).toUpperCase() +
      parts[parts.length - 1].charAt(0).toUpperCase()
    );
  }
  return parts[0].substring(0, 2).toUpperCase();
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    display: "none",
  },
}));

const WorkOrderMobile = ({ isPanelOpen, onToggle, requestData, appointments, setRequestData, setSnackbarOpen, setSnackbarMsg, setLoading, contractors, labors, materials, vehicles }) => {
  const { getAccessTokenSilently } = useAuth0();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [openAppointment, setOpenAppointment] = useState(false);
  const [openContractor, setOpenContractor] = useState(false);
  const [openLabor, setOpenLabor] = useState(false);
  const [openMaterial, setOpenMaterial] = useState(false);
  const [openVehicle, setOpenVehicle] = useState(false);
  const [addVehicleModalOpen, setAddVehicleModalOpen] = useState(false);
  const [appEditVehicleId, setAppEditVehicleId] = useState(0);
  const [appEditVehicleData, setAppEditVehicleData] = useState(null);
  const [addMaterialModalOpen, setAddMaterialModalOpen] = useState(false);
  const [appEditMaterialId, setAppEditMaterialId] = useState(0);
  const [appEditMaterialData, setAppEditMaterialData] = useState(null);
  const [addLaborModalOpen, setAddLaborModalOpen] = useState(false);
  const [appEditLaborId, setAppEditLaborId] = useState(0);
  const [appEditLaborData, setAppEditLaborData] = useState(null);
  const [addContractorModalOpen, setAddContractorModalOpen] = useState(false);
  const [appEditContractorId, setAppEditContractorId] = useState(0);
  const [appEditContractorData, setAppEditContractorData] = useState(null);
  const [addAppointmentModalOpen, setAddAppointmentModalOpen] = useState(false);
  const [appEditAppointmentId, setAppEditAppointmentId] = useState(0);
  const [appEditAppointmentData, setAppEditAppointmentData] = useState(null);
  const [appointmentList, setAppointmentList] = useState([]);
  const [deleteModalAppointmentOpen, setDeleteModalAppointmentOpen] = useState(false);
  const [appointmentDeleteId, setAppointmentDeleteId] = useState(0);
  const [contractorList, setContractorList] = useState([]);
  const [deleteModalContractorOpen, setDeleteModalContractorOpen] = useState(false);
  const [contractorDeleteId, setContractorDeleteId] = useState(0);
  const [laborList, setLaborList] = useState([]);
  const [deleteModalLaborOpen, setDeleteModalLaborOpen] = useState(false);
  const [laborDeleteId, setLaborDeleteId] = useState(0);
  const [materialList, setMaterialList] = useState([]);
  const [deleteModalMaterialOpen, setDeleteModalMaterialOpen] = useState(false);
  const [materialDeleteId, setMaterialDeleteId] = useState(0);
  const [vehicleList, setVehicleList] = useState([]);
  const [deleteModalVehicleOpen, setDeleteModalVehicleOpen] = useState(false);
  const [vehicleDeleteId, setVehicleDeleteId] = useState(0);

  useEffect(() => {
    if (appointments) {
      setAppointmentList(appointments);
    }
  }, [appointments]);

  useEffect(() => {
    if (contractors) {
      setContractorList(contractors);
    }
  }, [contractors]);

  useEffect(() => {
    if (labors) {
      setLaborList(labors);
    }
  }, [labors]);

  useEffect(() => {
    if (materials) {
      setMaterialList(materials);
    }
  }, [materials]);

  useEffect(() => {
    if (vehicles) {
      setVehicleList(vehicles);
    }
  }, [vehicles]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }

  const delAppointmentConfirm = async () => {
    setDeleteModalAppointmentOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id + "/appointments/" + appointmentDeleteId, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      let appointment = appointments.filter((item) => item.id === appointmentDeleteId);

      setRequestData((prev) => {
        let appointments = prev?.appointments?.filter((i) => i?.id !== appointmentDeleteId);
        return { ...prev, appointments: appointments };
      });

      let logData = {
        title: "Maintenance request appointment is deleted",
        description: [
          "Name: " + requestData?.title,
          "Request number: " + requestData?.request_no,
          "Property: " + requestData?.property_name,
          "Apartment: " + requestData?.apt_name,
          "Tenant: " + requestData?.tenant_name,
          "Technician: " + appointment[0].assignee_name,
          "Appointment date: " + dayjs(appointment[0].date).format("L"),
          "Appointment time: " + appointment[0].time,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const delContractorConfirm = async () => {
    setDeleteModalContractorOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id + "/contractors/" + contractorDeleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setRequestData((prev) => {
        let contractors = prev?.contractors?.filter((i) => i?.id !== contractorDeleteId);
        return { ...prev, contractors: contractors };
      });

      let logData = {
        title: "Maintenance request contractor is deleted",
        description: [
          "Name: " + requestData?.title,
          "Request number: " + requestData?.request_no,
          "Property: " + requestData?.property_name,
          "Apartment: " + requestData?.apt_name,
          "Tenant: " + requestData?.tenant_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const delLaborConfirm = async () => {
    setDeleteModalLaborOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id + "/appointment-labors/" + laborDeleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setRequestData((prev) => {
        let labors = prev?.labors?.filter((i) => i?.id !== laborDeleteId);
        return { ...prev, labors: labors };
      });

      let logData = {
        title: "Maintenance request labor is deleted",
        description: [
          "Name: " + requestData?.title,
          "Request number: " + requestData?.request_no,
          "Property: " + requestData?.property_name,
          "Apartment: " + requestData?.apt_name,
          "Tenant: " + requestData?.tenant_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const delMaterialConfirm = async () => {
    setDeleteModalMaterialOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id + "/appointment-materials/" + materialDeleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setRequestData((prev) => {
        let materials = prev?.materials?.filter((i) => i?.id !== materialDeleteId);
        return { ...prev, materials: materials };
      });

      let logData = {
        title: "Maintenance request material is deleted",
        description: [
          "Name: " + requestData?.title,
          "Request number: " + requestData?.request_no,
          "Property: " + requestData?.property_name,
          "Apartment: " + requestData?.apt_name,
          "Tenant: " + requestData?.tenant_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  const delVehilceConfirm = async () => {
    setDeleteModalVehicleOpen(false);
    setLoading(true);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    return axios.delete(process.env.REACT_APP_CASE_API_URL + "v1/maintenance-requests/" + requestData?.id + "/appointment-vehicles/" + vehicleDeleteId, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((response) => {
      setLoading(false);

      setSnackbarOpen(true);
      setSnackbarMsg(response.data.message);

      setRequestData((prev) => {
        let vehicles = prev?.vehicles?.filter((i) => i?.id !== vehicleDeleteId);
        return { ...prev, vehicles: vehicles };
      });

      let logData = {
        title: "Maintenance request vehicle is deleted",
        description: [
          "Name: " + requestData?.title,
          "Request number: " + requestData?.request_no,
          "Property: " + requestData?.property_name,
          "Apartment: " + requestData?.apt_name,
          "Tenant: " + requestData?.tenant_name,
        ],
      };
      AddLogCallAPI(logData, token);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (
    <>
      <div className={`${styles.AccordionList}`}>
        <div className={`${styles.AccordionListHead} ${isPanelOpen ? styles.Open : ""}`} onClick={() => onToggle("three")}>
          <p className={`${styles.Title}`}>Work Order</p>
          <img src="/static/img/downTriangle.svg" />
        </div>
        <div className={`${styles.AccordionListBody} ${isPanelOpen ? styles.Open : ""}`}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            className={`${styles.WorkOrderTab} WorkOrderTab`}
          >
            <Tab label="Appointments" {...a11yProps(0)} />
            <Tab label="Contractor" {...a11yProps(1)} />
            <Tab label="Labor" {...a11yProps(2)} />
            <Tab label="Materials" {...a11yProps(3)} />
            <Tab label="Vehicle" {...a11yProps(4)} />
          </Tabs>
          <CustomTabPanel value={value} index={0}>
            <div className={`${styles.TabBodySec}`}>
              {appointmentList?.map((item) => {
                return (<div className={`${styles.WorkOrderCard}`}>
                  <div className={`${styles.CardAvatar}`}><p><Initials fullName={item.assignee_name} /></p></div>
                  <div className={`${styles.CardDetails}`}>
                    <p className={`${styles.Title}`}>{item.assignee_name}</p>
                    <p className={`${styles.SubTitle}`}>{dayjs(item.date).format("L")} <span>{item.time}</span></p>
                    <div className={`${styles.WorkOrderActionBU}`}>
                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDDAction}`}>
                          <MoreVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddAppointmentModalOpen(true); setAppEditAppointmentId(item?.id); setAppEditAppointmentData(item); }}>
                            <Edit /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalAppointmentOpen(true); setAppointmentDeleteId(item?.id); }}>
                            <Trash2 /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>);
              })}

              {appointmentList?.length === 0 && (<div className={`${styles.NoDataMainWithBU}`}>
                <div>
                  <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/appointments-icon.svg" alt="" /></div>
                  <p className={`${styles.NoDataTextWithBU}`}>Appointments List is Empty</p>
                  <p className={`${styles.NoDataTextSubWithBU}`}>What do you want to do today?</p>
                </div>
              </div>)}

              <button className={`${styles.AddBU}`} onClick={(e) => { setAddAppointmentModalOpen(true); setAppEditAppointmentId(0); setAppEditAppointmentData(null); }}><Plus /> Add a appointment</button>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <div className={`${styles.TabBodySec}`}>
              {contractorList?.map((item) => {
                return (<div className={`${styles.WorkOrderCard}`}>
                  <div className={`${styles.CardAvatar}`}><p><Initials fullName={item.contractor_name} /></p></div>
                  <div className={`${styles.CardDetails}`}>
                    <p className={`${styles.Title}`}>{item?.contractor_name}</p>
                    <p className={`${styles.SubTitle}`}>{dayjs(item.date).format("L")} {item?.file_path !== "" && (<Link to={{ pathname: item?.file_url }} className={`${styles.Link}`}><FileText /> Receipt</Link>)}</p>
                    <p className={`${styles.SubTitle}`}>{item?.description}</p>
                    <div className={`${styles.WorkOrderActionBU}`}>
                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDDAction}`}>
                          <MoreVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddContractorModalOpen(true); setAppEditContractorId(item?.id); setAppEditContractorData(item); }}>
                            <Edit /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalContractorOpen(true); setContractorDeleteId(item?.id); }}>
                            <Trash2 /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>);
              })}

              {contractorList?.length === 0 && (<div className={`${styles.NoDataMainWithBU}`}>
                <div>
                  <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/no-architect.png" alt="" /></div>
                  <p className={`${styles.NoDataTextWithBU}`}>Hey there!</p>
                  <p className={`${styles.NoDataTextSubWithBU}`}>No contractor is available at this time.</p>
                </div>
              </div>)}

              <button className={`${styles.AddBU}`} onClick={(e) => { setAddContractorModalOpen(true); setAppEditContractorId(0); setAppEditContractorData(null); }}><Plus /> Add a contractor</button>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <div className={`${styles.TabBodySec}`}>
              {laborList?.map((item) => {
                return (<div className={`${styles.WorkOrderCard}`}>
                  <div className={`${styles.CardAvatar}`}><p><Initials fullName={item.technician_name} /></p></div>
                  <div className={`${styles.CardDetails}`}>
                    <p className={`${styles.Title}`}>{item.technician_name}</p>
                    <p className={`${styles.SubTitle}`}>{dayjs(item.date).format("L")} <span>{item?.spent_time}</span></p>
                    <div className={`${styles.WorkOrderActionBU}`}>
                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDDAction}`}>
                          <MoreVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddLaborModalOpen(true); setAppEditLaborId(item?.id); setAppEditLaborData(item); }}>
                            <Edit /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalLaborOpen(true); setLaborDeleteId(item?.id); }}>
                            <Trash2 /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>);
              })}

              {laborList?.length === 0 && (<div className={`${styles.NoDataMainWithBU}`}>
                <div>
                  <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/no-labourer.png" alt="" /></div>
                  <p className={`${styles.NoDataTextWithBU}`}>Unfortunately!</p>
                  <p className={`${styles.NoDataTextSubWithBU}`}>Labors are not added at this time.</p>
                </div>
              </div>)}

              <button className={`${styles.AddBU}`} onClick={(e) => { setAddLaborModalOpen(true); setAppEditLaborId(0); setAppEditLaborData(null); }}><Plus /> Add a labor</button>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            <div className={`${styles.TabBodySec}`}>
              {materialList?.map((item) => {
                return (<div className={`${styles.WorkOrderCard}`}>
                  <div className={`${styles.CardAvatar}`}><p><Initials fullName={item.technician_name} /></p></div>
                  <div className={`${styles.CardDetails}`}>
                    <p className={`${styles.Title}`}>{item?.technician_name}</p>
                    <p className={`${styles.SubTitle}`}>{dayjs(item.date).format("L")} {item?.file_path !== "" && (<Link to={{ pathname: item?.file_url }} className={`${styles.Link}`}><FileText /> Receipt</Link>)}</p>
                    <p className={`${styles.SubTitle}`}>{item?.materials}</p>
                    <div className={`${styles.WorkOrderActionBU}`}>
                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDDAction}`}>
                          <MoreVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddMaterialModalOpen(true); setAppEditMaterialId(item?.id); setAppEditMaterialData(item); }}>
                            <Edit /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalMaterialOpen(true); setMaterialDeleteId(item?.id); }}>
                            <Trash2 /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>)
              })}

              {materialList?.length === 0 && (<div className={`${styles.NoDataMainWithBU}`}>
                <div>
                  <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/material.png" alt="" /></div>
                  <p className={`${styles.NoDataTextWithBU}`}>Nothing here</p>
                  <p className={`${styles.NoDataTextSubWithBU}`}>No materials are added at this time.</p>
                </div>
              </div>)}


              <button className={`${styles.AddBU}`} onClick={(e) => { setAddMaterialModalOpen(true); setAppEditMaterialId(0); setAppEditMaterialData(null); }}><Plus /> Add a material</button>
            </div>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={4}>
            <div className={`${styles.TabBodySec}`}>
              {vehicleList?.map((item) => {
                return (<div className={`${styles.WorkOrderCard}`}>
                  <div className={`${styles.CardAvatar}`}><p><Initials fullName={item?.technician_name} /></p></div>
                  <div className={`${styles.CardDetails}`}>
                    <p className={`${styles.Title}`}>{item?.technician_name}</p>
                    <p className={`${styles.SubTitle}`}>{dayjs(item.date).format("L")} {item?.file_path !== "" && (<Link className={`${styles.Link}`} to={{ pathname: item?.file_url }} target="_blank"><FileText /> Receipt</Link>)}</p>
                    <p className={`${styles.SubTitle}`}>{item?.vehicle} <span>{item?.miles}</span></p>
                    <div className={`${styles.WorkOrderActionBU}`}>
                      <Dropdown>
                        <Dropdown.Toggle id="dropdown-basic" className={`${styles.FilesUpCardDDAction}`}>
                          <MoreVertical />
                        </Dropdown.Toggle>

                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setAddVehicleModalOpen(true); setAppEditVehicleId(item?.id); setAppEditVehicleData(item); }}>
                            <Edit /> Edit
                          </Dropdown.Item>
                          <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteModalVehicleOpen(true); setVehicleDeleteId(item?.id); }}>
                            <Trash2 /> Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>);
              })}

              {vehicleList?.length === 0 && (<div className={`${styles.NoDataMainWithBU}`}>
                <div>
                  <div className={`${styles.NoDataIMGWithBU}`}><img src="/static/img/vehicle-icon.svg" alt="" /></div>
                  <p className={`${styles.NoDataTextWithBU}`}>Unfortunately!</p>
                  <p className={`${styles.NoDataTextSubWithBU}`}>Vehicle are not added at this time.</p>
                </div>
              </div>)}


              <button className={`${styles.AddBU}`} onClick={(e) => { setAddVehicleModalOpen(true); setAppEditVehicleId(0); setAppEditVehicleData(null); }}><Plus /> Add a vehicle</button>
            </div>
          </CustomTabPanel>
        </div>
      </div>

      <Dialog
        open={addAppointmentModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={(e) => setAddAppointmentModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setAddAppointmentModalOpen(false)}><ArrowLeft /></button>
          {appEditAppointmentId ? "Edit Appointment" : "Add Appointment"}
          <button onClick={(e) => setAddAppointmentModalOpen(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <AppointmentAdd
            appEditId={appEditAppointmentId}
            appEditData={appEditAppointmentData}
            requestData={requestData}
            setRequestData={setRequestData.bind(this)}
            setAddModalOpen={setAddAppointmentModalOpen.bind(this)}
            setSnackbarOpen={setSnackbarOpen.bind(this)}
            setSnackbarMsg={setSnackbarMsg.bind(this)}
            setLoading={setLoading.bind(this)}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={addContractorModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={(e) => setAddContractorModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setAddContractorModalOpen(false)}><ArrowLeft /></button>
          {appEditContractorId ? "Edit Contractor" : "Add Contractor"}
          <button onClick={(e) => setAddContractorModalOpen(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <ContractorAdd
            appEditId={appEditContractorId}
            appEditData={appEditContractorData}
            requestData={requestData}
            setRequestData={setRequestData.bind(this)}
            setAddModalOpen={setAddContractorModalOpen.bind(this)}
            setSnackbarOpen={setSnackbarOpen.bind(this)}
            setSnackbarMsg={setSnackbarMsg.bind(this)}
            setLoading={setLoading.bind(this)}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={addLaborModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={(e) => setAddLaborModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setAddLaborModalOpen(false)}><ArrowLeft /></button>
          {appEditLaborId ? "Edit Labor" : "Add Labor"}
          <button onClick={(e) => setAddLaborModalOpen(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <LaborAdd
            appEditId={appEditLaborId}
            appEditData={appEditLaborData}
            requestData={requestData}
            setRequestData={setRequestData.bind(this)}
            setAddModalOpen={setAddLaborModalOpen.bind(this)}
            setSnackbarOpen={setSnackbarOpen.bind(this)}
            setSnackbarMsg={setSnackbarMsg.bind(this)}
            setLoading={setLoading.bind(this)}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={addMaterialModalOpen}
        fullWidth
        maxWidth="xs"
        onClose={(e) => setAddMaterialModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setAddMaterialModalOpen(false)}><ArrowLeft /></button>
          {appEditVehicleId ? "Edit Material" : "Add Material"}
          <button onClick={(e) => setAddMaterialModalOpen(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <MaterialAdd
            appEditId={appEditMaterialId}
            appEditData={appEditMaterialData}
            requestData={requestData}
            setRequestData={setRequestData.bind(this)}
            setAddModalOpen={setAddMaterialModalOpen.bind(this)}
            setSnackbarOpen={setSnackbarOpen.bind(this)}
            setSnackbarMsg={setSnackbarMsg.bind(this)}
            setLoading={setLoading.bind(this)}
          />
        </DialogContent>
      </Dialog>


      <Dialog
        open={addVehicleModalOpen}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setAddVehicleModalOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp MobileForm"
      >
        <DialogTitle id="alert-dialog-title">
          <button className={`${styles.BackAddBU}`} onClick={(e) => setAddVehicleModalOpen(false)}><ArrowLeft /></button>
          {appEditVehicleId ? "Edit Vehicle" : "Add Vehicle"}
          <button onClick={(e) => setAddVehicleModalOpen(false)}>
            <X />
          </button>
        </DialogTitle>
        <DialogContent className={`${styles.RequestBodyPop}`}>
          <VehicleAdd
            appEditId={appEditVehicleId}
            appEditData={appEditVehicleData}
            requestData={requestData}
            setRequestData={setRequestData.bind(this)}
            setAddModalOpen={setAddVehicleModalOpen.bind(this)}
            setSnackbarOpen={setSnackbarOpen.bind(this)}
            setSnackbarMsg={setSnackbarMsg.bind(this)}
            setLoading={setLoading.bind(this)}
          />
        </DialogContent>
      </Dialog >


      <Dialog
        open={deleteModalAppointmentOpen}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setDeleteModalAppointmentOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the appointment?<button onClick={(e) => setDeleteModalAppointmentOpen(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The appointment will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => delAppointmentConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setDeleteModalAppointmentOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteModalContractorOpen}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setDeleteModalContractorOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the contractor?<button onClick={(e) => setDeleteModalContractorOpen(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The contractor will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => delContractorConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setDeleteModalContractorOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteModalLaborOpen}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setDeleteModalLaborOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the labour?<button onClick={(e) => setDeleteModalLaborOpen(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The labour will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => delLaborConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setDeleteModalLaborOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteModalMaterialOpen}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setDeleteModalMaterialOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the material?<button onClick={(e) => setDeleteModalMaterialOpen(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The material will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => delMaterialConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setDeleteModalMaterialOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteModalVehicleOpen}
        fullWidth
        maxWidth="sm"
        onClose={(e) => setDeleteModalVehicleOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="NewPopUp"
      >
        <DialogTitle id="alert-dialog-title">Are you sure you want to delete the vehicle?<button onClick={(e) => setDeleteModalVehicleOpen(false)}><X /></button></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div className="ModalFormGroup">
              <label className="PopupBodyText">The vehicle will be removed immediately.You can't undo this action.</label>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="CancelPopupBU" onClick={(e) => delVehilceConfirm()}>Delete</Button>
          <Button className="SubmitPopupBU" onClick={(e) => setDeleteModalVehicleOpen(false)}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default WorkOrderMobile;
